import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Plot from 'react-plotly.js';
import axios from 'axios';

const ProjectReport = () => {
  const [projectData, setProjectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjectData = async () => {
      setLoading(true);
      try {
        const URL = process.env.REACT_APP_BE_URL + "/projectUtilization";
        const response = await axios.get(URL, {
          headers: {
            Authorization: `Bearer ${token}`
          },
        });
        setProjectData(response.data);
      } catch (error) {
        console.error("Error fetching project report:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, []);

  const projectNames = projectData.map((item) => item.projectName);
  const utilizationHours = projectData.map((item) => item.utilizationHours);

  return (
    <div>
      <div className="content-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="p-6 bg-white min-h-screen">
                <button 
                  type="button" 
                  className="btn btn-secondary mb-4" 
                  onClick={() => navigate('/utilization')}
                >
                  ← Back to Utilization
                </button>
                <h2 className="text-2xl font-semibold mb-6">Project Utilization Report</h2>

                {loading ? (
                  <div className="text-center text-gray-600 py-20">Loading...</div>
                ) : (
                  <div>
                    {/* Bar Chart */}
                    <div className="mb-8">
                      <Plot
                        data={[
                          {
                            x: projectNames,
                            y: utilizationHours,
                            type: 'bar',
                            marker: { color: 'rgb(66, 135, 245)' },
                          },
                        ]}
                        layout={{
                          width: 700,
                          height: 400,
                          title: 'Utilization Hours by Project',
                          xaxis: { title: 'Project Name' },
                          yaxis: { title: 'Utilization Hours' },
                        }}
                      />
                    </div>

                    {/* Project Details Table */}
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white border border-gray-200">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="py-2 px-4 border-b text-left">Project Name</th>
                            <th className="py-2 px-4 border-b text-left">Project Code</th>
                            <th className="py-2 px-4 border-b text-left">Utilization Hours</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projectData.map((project, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="py-2 px-4 border-b">{project.projectName}</td>
                              <td className="py-2 px-4 border-b">{project.projectCode}</td>
                              <td className="py-2 px-4 border-b">{project.utilizationHours}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectReport;